export default __webpack_public_path__ + "static/logo-mobile-f189c5b13c2ce4acad8d1dd90bf5f5f8.png";